module.exports = __webpack_public_path__ + "static/media/thermometer-empty.0823d181.svg";